import React, { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import "./AdminDashboard.css";
import AdminleftSide from "./AdminleftSide";
import DashboardLayout from "./DashboardLayout";
import axios from "axios";

const Myprofile = ({ userType }) => {
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const [stats, setStats] = useState(null);
  const [last30DaysCompanyNames, setLast30DaysCompanyNames] = useState(null);

  useEffect(() => {
    axios
      .get(`${BASE_API_URL}/getReport`)
      .then((response) => {
        setStats(response.data);
      })
      .catch((error) => {
        console.error("Error fetching dashboard stats:", error);
      });

    axios
      .get(`${BASE_API_URL}/getCompanyNamesJoinedInLast30Days`)
      .then((response) => {
        setLast30DaysCompanyNames(response.data);
      })
      .catch((error) => {
        console.error("Error fetching company names:", error);
      });
  }, []);
  const handleSendEmail = () => {
    if (!stats || !last30DaysCompanyNames) {
      alert("Data is not loaded yet!");
      return;
    }

    // Serialize stats as JSON string
    const statsParam = encodeURIComponent(JSON.stringify(stats));
    // Serialize company names as JSON string
    const companiesParam = encodeURIComponent(
      JSON.stringify(last30DaysCompanyNames),
    );
    const recipient = encodeURIComponent("mis@jobbox.one");

    const url = `${BASE_API_URL}/sendReportEmail?recipient=${recipient}&stats=${statsParam}&last30DaysCompanyNames=${companiesParam}`;

    axios
      .post(url)
      .then((response) => {
        alert("Report sent successfully!");
      })
      .catch((error) => {
        console.error("Failed to send report:", error);
        alert("Failed to send report. Please try again later.");
      });
  };

  return (
    <DashboardLayout>
      <div style={{ maxWidth: "900px", margin: "20px auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "20px",
          }}
        >
          <Button
            onClick={handleSendEmail}
            style={{ padding: "8px 16px", cursor: "pointer" }}
          >
            Send Report via Email
          </Button>
        </div>

        {/* Statistics Section */}
        <div style={{ marginBottom: "40px" }}>
          <h2
            style={{ marginBottom: "20px", fontSize: "18px", color: "#222222" }}
          >
            Dashboard Statistics
          </h2>

          {stats ? (
            <Table
              responsive
              bordered
              style={{ fontSize: "14px", borderColor: "#e3e7ec" }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f2f4f7", color: "#222222" }}>
                  <th style={{ padding: "10px", backgroundColor: "#f2f4f7" }}>
                    Metric
                  </th>
                  <th
                    style={{
                      padding: "10px",
                      backgroundColor: "#f2f4f7",
                      textAlign: "center",
                    }}
                  >
                    Last 1 Day
                  </th>
                  <th
                    style={{
                      padding: "10px",
                      backgroundColor: "#f2f4f7",
                      textAlign: "center",
                    }}
                  >
                    Last 7 Days
                  </th>
                  <th
                    style={{
                      padding: "10px",
                      backgroundColor: "#f2f4f7",
                      textAlign: "center",
                    }}
                  >
                    Last 30 Days
                  </th>
                  <th
                    style={{
                      padding: "10px",
                      backgroundColor: "#f2f4f7",
                      textAlign: "center",
                    }}
                  >
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {[
                  {
                    label: "Candidates",
                    d1: stats.candidatesLast1Day,
                    d7: stats.candidatesLast7Days,
                    d30: stats.candidatesLast30Days,
                    total: stats.totalCandidates,
                  },
                  {
                    label: "Verified Candidates",
                    d1: stats.verifiedCandidatesLast1Day,
                    d7: stats.verifiedCandidatesLast7Days,
                    d30: stats.verifiedCandidatesLast30Days,
                    total: stats.totalVerifiedCandidates,
                  },
                  {
                    label: "HRs",
                    d1: stats.hrsLast1Day,
                    d7: stats.hrsLast7Days,
                    d30: stats.hrsLast30Days,
                    total: stats.totalHRs,
                  },
                  {
                    label: "Companies",
                    d1: stats.companiesLast1Day,
                    d7: stats.companiesLast7Days,
                    d30: stats.companiesLast30Days,
                    total: stats.totalCompanies,
                  },
                  {
                    label: "Jobs",
                    d1: stats.jobsLast1Day,
                    d7: stats.jobsLast7Days,
                    d30: stats.jobsLast30Days,
                    total: stats.totalJobs,
                  },
                  {
                    label: "Applications",
                    d1: stats.applicationsLast1Day,
                    d7: stats.applicationsLast7Days,
                    d30: stats.applicationsLast30Days,
                    total: stats.totalApplications,
                  },
                ].map((row, i) => (
                  <tr
                    key={row.label}
                    style={{
                      backgroundColor: i % 2 === 0 ? "#ffffff" : "#f8fafc",
                    }}
                  >
                    <td style={{ padding: "10px", fontWeight: "bold" }}>
                      {row.label}
                    </td>
                    <td style={{ padding: "10px", textAlign: "center" }}>
                      {row.d1}
                    </td>
                    <td style={{ padding: "10px", textAlign: "center" }}>
                      {row.d7}
                    </td>
                    <td style={{ padding: "10px", textAlign: "center" }}>
                      {row.d30}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        textAlign: "center",
                        fontWeight: "bold",
                        backgroundColor: "#f5f7fa",
                      }}
                    >
                      {row.total}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p>Loading statistics...</p>
          )}
        </div>

        {/* Companies Joined Section */}
        <div>
          <h3
            style={{ marginBottom: "20px", fontSize: "16px", color: "#222222" }}
          >
            Companies Joined in Last 30 Days
          </h3>

          {last30DaysCompanyNames && last30DaysCompanyNames.length > 0 ? (
            <Table
              responsive
              bordered
              style={{ fontSize: "14px", borderColor: "#e3e7ec" }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      padding: "10px",
                      width: "60px",
                      textAlign: "center",
                      backgroundColor: "#f2f4f7",
                    }}
                  >
                    #
                  </th>
                  <th style={{ padding: "10px", backgroundColor: "#f2f4f7" }}>
                    Company Name
                  </th>
                </tr>
              </thead>
              <tbody>
                {last30DaysCompanyNames.map((name, index) => (
                  <tr key={index}>
                    <td style={{ padding: "10px", textAlign: "center" }}>
                      {index + 1}
                    </td>
                    <td style={{ padding: "10px" }}>{name}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p style={{ color: "#888888" }}>
              No new companies in the last 30 days.
            </p>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Myprofile;
